import { createActions, createReducer } from 'reduxsauce';

export const { Types, Creators } = createActions({
  incrementNotificationCounter: null,
});

const INITIAL_STATE = {
  notificationCounter: 0,
};

const incrementNotificationCounter = (state = INITIAL_STATE) => {
  return {
    ...state,
    notificationCounter: state.notificationCounter + 1,
  };
};

export default createReducer(INITIAL_STATE, {
  [Types.INCREMENT_NOTIFICATION_COUNTER]: incrementNotificationCounter,
});
